var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 4.75C1.25 4.19772 1.69772 3.75 2.25 3.75H17.75C18.3023 3.75 18.75 4.19772 18.75 4.75V15.875C18.75 16.4273 18.3023 16.875 17.75 16.875H2.25C1.69772 16.875 1.25 16.4273 1.25 15.875V4.75ZM4.53125 4.84375H2.34375V7.03125L4.53125 4.84375ZM17.6562 4.84375H15.4688L17.6562 7.03125V4.84375ZM4.53125 15.7812H2.34375V13.5938L4.53125 15.7812ZM17.6562 15.7812H15.4688L17.6562 13.5938V15.7812Z",
    fill: "url(#paint0_linear_5_19002)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.635L12.075 13.89C12.455 14.12 12.92 13.78 12.82 13.35L12.27 10.99L14.105 9.40001C14.44 9.11001 14.26 8.56001 13.82 8.52501L11.405 8.32001L10.46 6.09C10.29 5.685 9.71004 5.685 9.54004 6.09L8.59504 8.31501L6.18004 8.52C5.74004 8.55501 5.56004 9.10501 5.89504 9.395L7.73004 10.985L7.18004 13.345C7.08004 13.775 7.54504 14.115 7.92504 13.885L10 12.635Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_19002",
    x1: 1.25,
    y1: 10.3125,
    x2: 18.75,
    y2: 10.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501041,
    stopColor: "#64BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4395F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyChecker);
export default __webpack_public_path__ + "static/media/daily_checker.6cd8bc2bd00a728fbdaa46ed20c46dca.svg";
export { ForwardRef as ReactComponent };